import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { apiConfig } from '../../../environments/b2c-config';
import { MsalService } from '@azure/msal-angular';
import { StoreAuthService } from '@app/core/auth/store-auth.service';
import { DatabaseCacheService } from '../cache/database-cache.service';

@Injectable({
  providedIn: 'root'
})
export class DeleteMediaService {

  headers = new HttpHeaders({
    'Content-Type': 'application/json'
  });

  params = new HttpParams();

  constructor(
    private httpClient: HttpClient,
    private msalService: MsalService,
    private common: DatabaseCacheService
  ) { }

  deleteMedia(mediaId) {
    let sectionId = this.common.getSelectedSection().sectionId;

    let user = this.msalService.instance.getActiveAccount();
    let loginUserId = JSON.stringify(user.idTokenClaims['sub']);

    this.headers = this.headers.set('LoginUserId', loginUserId)
      .set('Access-Control-Allow-Origin', '*');

    var apiUrl = `${apiConfig.uri}/licence/${sectionId}/medias/${mediaId}`

    return this.httpClient.delete(apiUrl, { params: this.params, headers: this.headers });
  }
}
